export function googleAuthOutcome(status, data) {
  if (data?.status === 'pending_approval' || status === 202) return 'pending';
  if (data?.status === 'rejected') return 'rejected';
  if (data?.token) return 'session';
  return 'error';
}

export function clearAdminSession() {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
}
